import React, { Component } from 'react'
import PropTypes from 'prop-types'

import FractionBoxProgress from './fraction_box_progress'

/**
 * 置信度报告
 */
export default class ConfidenceBox extends Component {

    static propTypes = {
        data: PropTypes.array,
    }

    render() {
        return (
            <FractionBoxProgress title="置信度报告" data={this.props.data} />
        )
    }
}